import React from "react";
import "./styles.scss";
import optimizeModalData from "../../assets/data/optimize-modal";

import ValueCell from "../../components/ValueCell";
import { TypeFormation } from "../../models/Formation";

interface OptimizeModalProps {
  type?: TypeFormation;
}

const OptimizeModal: React.FC<OptimizeModalProps> = ({ type }) => {
  const displayedItems =
    type && type === TypeFormation.BilanDeCompetence
      ? optimizeModalData.slice(-2)
      : optimizeModalData.slice(0, 2);

  return (
    <div className="optimize-modal">
      <h2>Optimiser les financements</h2>
      <p>
        La formation professionnelle permet d’adapter les compétences des
        salariés aux nouveaux besoins, d’optimiser les atouts du groupe, et de
        renforcer la cohésion d’équipe en alignant les intérêts des
        collaborateurs avec ceux de la structure.
      </p>
      {type && type === TypeFormation.BilanDeCompetence ? (
        <p>
          <br />
          Suite à la parution d’un article sur Centre Inffo, les conditions
          d’éligibilité aux financements publics ont été renforcées pour les
          organismes de formation. NATELCO a mis à jour ses outils et documents
          pour accompagner ses bénéficiaires dans l’accès aux financements,
          notamment le CPF.
          <br />
          <br />À noter : NATELCO est en attente de validation de son
          référencement à l’EDOF (Espace des Organismes de Formation) pour que
          son bilan de compétences soit finançable via le CPF. Dès validation,
          l’information sera visible sur{" "}
          <a href="https://moncompteformation.gouv.fr" target="_blank">
            MonCompteFormation.gouv.fr
          </a>
          .
        </p>
      ) : null}
      <div className="optimize-modal-container">
        {displayedItems.map((optimize, index) => (
          <ValueCell
            key={index}
            icon={optimize.icon}
            color={optimize.color}
            title={optimize.title}
            description={optimize.description}
          />
        ))}
      </div>
    </div>
  );
};

export default OptimizeModal;
